/* tslint:disable */
/* eslint-disable */
/**
 * MG-DX Pharmacy Counselor API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.2.0
 * Contact: developers@mg-dx.co.jp
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { tzDate } from "@mgdx-libs/dayjs";
import { exists, mapValues } from "../runtime";

export const PharmacyCounselorInterviewTypename = "PharmacyCounselorInterview" as const;

/**
 *
 * @export
 * @interface PharmacyCounselorInterview
 */
export interface PharmacyCounselorInterview {
  /**
   *
   * @type {Date}
   * @memberof PharmacyCounselorInterview
   */
  answeredTime?: string;
  /**
   *
   * @type {string}
   * @memberof PharmacyCounselorInterview
   */
  interviewsType: PharmacyCounselorInterviewInterviewsTypeEnum;
  /**
   *
   * @type {Date}
   * @memberof PharmacyCounselorInterview
   */
  lastConfirmedTime?: string;
  /**
   * Keys except key 'questionnaires' are for custom use only
   * @type {object}
   * @memberof PharmacyCounselorInterview
   */
  questionnaires: object;
  /**
   *
   * @type {number}
   * @memberof PharmacyCounselorInterview
   */
  version: number;
  /**
   * Resource type name
   * @type {string}
   * @memberof PharmacyCounselorInterview
   */
  readonly __typename?: string;
}

/**
 * @export
 * @enum {string}
 */
export enum PharmacyCounselorInterviewInterviewsTypeEnum {
  Default = "default",
  Custom = "custom",
  Unused = "unused",
}

export function PharmacyCounselorInterviewFromJSON(json: any): PharmacyCounselorInterview {
  return PharmacyCounselorInterviewFromJSONTyped(json, false);
}

export function PharmacyCounselorInterviewFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean
): PharmacyCounselorInterview {
  if (json === undefined || json === null) {
    return json;
  }
  return {
    __typename: PharmacyCounselorInterviewTypename,

    answeredTime:
      !exists(json, "answered_time") ||
      (typeof json["answered_time"] === "string" && json["answered_time"].substring(0, 4) === "0001")
        ? undefined
        : json["answered_time"],
    interviewsType: json["interviews_type"],
    lastConfirmedTime:
      !exists(json, "last_confirmed_time") ||
      (typeof json["last_confirmed_time"] === "string" && json["last_confirmed_time"].substring(0, 4) === "0001")
        ? undefined
        : json["last_confirmed_time"],
    questionnaires: json["questionnaires"],
    version: json["version"],
  };
}

export function PharmacyCounselorInterviewToJSON(object?: PharmacyCounselorInterview | null): any {
  if (object === undefined) {
    return undefined;
  }
  if (object === null) {
    return null;
  }
  const { __typename, ...value } = object;
  return {
    answered_time: value.answeredTime === undefined ? undefined : tzDate(value.answeredTime).format(),
    interviews_type: value.interviewsType,
    last_confirmed_time: value.lastConfirmedTime === undefined ? undefined : tzDate(value.lastConfirmedTime).format(),
    questionnaires: value.questionnaires,
    version: value.version,
  };
}
